import React from "react";

interface YearMonthPickerProps {
  year: string;
  month: string;
  years: string[];
  months: { value: string; label: string }[];
  onYearChange: (y: string) => void;
  onMonthChange: (m: string) => void;
}

const YearMonthPicker: React.FC<YearMonthPickerProps> = ({ year, month, years, months, onYearChange, onMonthChange }) => {
  return (
    <div className="flex gap-4 mb-6">
      <select
        value={year}
        onChange={(e) => onYearChange(e.target.value)}
        className="border px-2 py-1 rounded"
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>

      <select
        value={month}
        onChange={(e) => onMonthChange(e.target.value)}
        className="border px-2 py-1 rounded"
      >
        {months.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default YearMonthPicker;
